export const STORE_KEYS = {
  // tags store names
  taskTagValuesStore: "tasktagvalues",
  resourceTagValuesStore: "resourcetagvalues",
  clientTagValuesStore: "clienttagvalues",
  contactTagValuesStore: "contacttagvalues",
  // resource type store
  resourceTypeStore: "resourcetypes",
  // bpard store
  boardStore: "boards",
  boardClientAgendaStore: "boardclientagendas",
  clientAgendaStore: "clientagendas",
  boardPreferencesStore: "boardpreferences",
  taskBudgetStore: "taskbudgets",
  checklistStore: "checklists",
  checklistItemStore: "checklistitems",
  resourceAgendaStore: "resourceagendas",
  notifyeeBoardUsers: "notifyeeboardusers",
  reminderStore: "reminders",
  clientStore: "clients",
  taskStore: "tasks",
  resourceStore: "resources",
  contactStore: "contacts",
  taskContactStore: "taskcontacts",
  resourceContactStore: "resourcecontacts",
  clientContactStore: "clientcontacts",
  userContactStore: "boardusercontacts",
  boardUserStore: "boardusers",
  viewsFolderStore: "boardviewfolders",
  viewsStore: "boardviews",
  notifyPreferenceStore: "usernotifypreferences",
  boardTeamsStore: "boardteams",
  taskIntegrationsStore: "taskintegrations",
  resourceIntegrationsStore: "resourceintegrations",
  clientIntegrationsStore: "clientintegrations",
  boardNotesStore: "boardnotes",
  userPreferencesStore: "userpreferences",
  reminderRecipientStore: "reminderrecipients",
  eventStore: "events",
  extraBoardIntegrationsStore: "boardintegrations",
  nonWorkingTimeStore: "boardnonworkingtimes",
  taskPlanningDatesStore: "taskplanningdates",
  importBatchStore: "importbatchs",
  outcomeIncentiveStore: "outcomeincentives",
  incentivePointsStore: "incentivepoints",
  incentiveBoardPreferencesStore: "incentiveboardpreferences",
  outcomeIncentiveConditionsStore: "outcomeincentiveconditions",
  spotIncentiveStore: "spotincentives",
  incentiveTagCategoryStore: "spotincentivetagcategorys",
  incentiveTagsStore: "spotincentivetags",
  incentivePointTagsStore: "incentivepointtags",
  assignmentStore: "assignments",
  contextCardsStore: "contextcards",
  fieldAdvisorCardsStore: "fieldadvisorcards",
  insightsStore: "insights",
  marketingTagStore: "marketingtags",
  marketingAssetStore: "marketingassets",
  problemSolutionTagMapStore: "problemsolutiontagmaps",
  promotePromptCardStore: "promotepromptcards",
  marketingWorkfileStore: "marketingworkfiles",
  marketingWorkfileCardStore: "marketingworkfilecards",
  marketingPageStore: "marketingpages",
  marketingDocumentStore: "marketingdocuments",
  sitesStore: "sites",
  submissionsStore: "submissions",
  submissionfilesStore: "submissionfiles",
  locationStore: "locations",
  boardContextStore: "boardcontexts",
  boardContextGroupStore: "boardcontextgroups",
  boardContextStatementStore: "boardcontextstatements",
};
